<div class="overview">
    <div #overviewComponent class="overview-control" role="img" aria-label="Overview of the whole model. Drag the rectangle to move around the canvas."></div>
    @if (!graphComponent) {
        <p class="note">The overview appears once the model has loaded.</p>
    }
</div>
